import { render, staticRenderFns } from "./userRestricted.vue?vue&type=template&id=86abe076&"
import script from "./userRestricted.vue?vue&type=script&lang=js&"
export * from "./userRestricted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports